import React, { Component } from "react";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import { Auth, API, graphqlOperation } from "aws-amplify";
import { createCustomer, createVendor } from "../graphql/mutations";
import _ from "lodash";
import Validate from "./FormValidation";
import { connect } from "react-redux";
import * as actionTypes from "../redux/actions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import { spinnerService } from "@chevtek/react-spinners";
// import Context from '../data/context';

class ConfirmSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regType: "",
      userGrp: "",
      username: "",
      code: "",
      password: "",
      errors: {
        cognito: null,
        blankfield: false
      }
    };
  }
  // static contextType = Context;

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false
      }
    });
  };
  componentDidMount() {
    if (this.props.match.params.type === undefined) {
      this.setState({ regType: null, userGrp: null });
    } else if (this.props.match.params.type === "customer") {
      this.setState({ regType: "Customer", userGrp: "Customers" });
    } else if (this.props.match.params.type === "vendor") {
      this.setState({ regType: "Vendor", userGrp: "Vendors" });
    } else if (this.props.match.params.type === "tvendor") {
      this.setState({ regType: "Tire Vendor", userGrp: "TireVendors" });
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    let regType = "Customer";
    let userGrp = "Customers";
    if (this.props.match.params.type === undefined) {
      return;
    } else if (this.props.match.params.type === "vendor") {
      regType = "Vendor";
      userGrp = "Vendors";
    } else if (this.props.match.params.type === "tvendor") {
      regType = "Tire Vendor";
      userGrp = "TireVendors";
    }
    this.clearErrorState();
    const error = Validate(event, this.state);
    if (error) {
      this.setState({
        errors: { ...this.state.errors, ...error }
      });
    }
    // %%%%%%%%%%%%%%%%%%%%%%%%
    let {
      id,
      address,
      password,
      addressType,
      lat,
      lng,
      city,
      company,
      username,
      fName,
      lName,
      phoneNum,
      email,
      state,
      selectedInspectionType,
      zipCode
    } = JSON.parse(localStorage.getItem("userInfo"));
    let { code } = this.state;
    spinnerService.show("mySpinner");
    try {
      const confirmedUser = await Auth.confirmSignUp(username, code, {
        // Optional. Force user confirmation irrespective of existing alias. By default set to True.
        forceAliasCreation: true
      })
        .then(async data => {
          const loggedinuser = await Auth.signIn(username, password).then(
            user2 => {
              Promise.resolve(Auth.currentAuthenticatedUser()).then(user =>
                Auth.currentCredentials()
                  .then(credentials =>
                    Promise.resolve(
                      new CognitoIdentityServiceProvider({
                        apiVersion: "2016-04-18",
                        credentials: Auth.essentialCredentials(credentials),
                        region: "us-east-2"
                      })
                    )
                  )
                  .then(async client => {
                    await client
                      .adminAddUserToGroup({
                        GroupName: userGrp,
                        UserPoolId: user.pool.userPoolId,
                        Username: user.username
                      })
                      .promise();
                  })
                  .then(async () => {
                    let today = new Date();
                    let month =
                      today.getMonth() + 1 < 10
                        ? `0${today.getMonth() + 1}`
                        : today.getMonth() + 1;
                    let date =
                      today.getDate() < 10
                        ? `0${today.getDate()}`
                        : today.getDate();
                    let currentDate = `${today.getFullYear()}-${month}-${date}`;
                    let input = {};
                    if (userGrp === "Customers") {
                      input = {
                        id: username,
                        //calbitCustomerID: "123456",
                        companyName: company,
                        customerFirstName: fName,
                        customerLastName: lName,

                        accountStatus: "ACTIVE"
                      };
                      if (!_.isEmpty(email)) input.email = email;
                      if (!_.isEmpty(selectedInspectionType))
                        input.registeredInspectionType = selectedInspectionType;
                      let addr = {};
                      let customerAddresses = [];
                      if (!_.isEmpty(address)) addr.address = address;
                      if (!_.isEmpty(city)) addr.city = city;
                      if (!_.isEmpty(state)) addr.state = state;
                      if (!_.isEmpty(zipCode)) addr.zipCode = zipCode;
                      if (!_.isEmpty(phoneNum)) addr.phoneNo = phoneNum;

                      //if (!_.isEmpty(faxNo)) addr.faxNo = faxNo;
                      addr.locationLat = lat;
                      addr.locationLong = lng;

                      addr.addressType = "PRIMARY";
                      customerAddresses.push(addr);

                      if (customerAddresses.length > 0)
                        input.customerAddresses = customerAddresses;

                      let result = await API.graphql(
                        graphqlOperation(createCustomer, { input })
                      );
                    } else if (
                      userGrp === "Vendors" ||
                      userGrp === "TireVendors"
                    ) {
                      const vendorType =
                        userGrp === "Vendors" ? "VENDOR" : "TIREVENDOR";
                      input = {
                        id: username,
                        vendorType,
                        companyName: company,
                        firstName: fName,
                        lastName: lName,
                        phoneNo: phoneNum,
                        email: email,
                        accountStatus: "ACTIVE"
                      };

                      let addr = {};
                      if (!_.isEmpty(address)) addr.address = address;
                      if (!_.isEmpty(city)) addr.city = city;
                      if (!_.isEmpty(state)) addr.state = state;
                      if (!_.isEmpty(zipCode)) addr.zipCode = zipCode;
                      if (lat !== "") addr.locationLat = lat;
                      if (lng !== "") addr.locationLong = lng;

                      input.address = addr;

                      let result = await API.graphql(
                        graphqlOperation(createVendor, { input })
                      );
                    }
                    await Auth.signIn(username, password).then(userObj => {
                      spinnerService.hide("mySpinner");
                      toast.success("User Created");
                      this.props.storeUser(userObj);
                      this.props.storeProfile(input);
                    });
                  })
                  .catch(err => {
                    spinnerService.hide("mySpinner");
                    toast.error(err.message);
                  })
              );
            }
          );
        })
        .catch(err => {
          spinnerService.hide("mySpinner");
          toast.error(err.message);
        });
    } catch (err) {
      this.setState({
        errors: {
          ...this.state.errors,
          cognito: err
        }
      });
    }
    // spinnerService.hide("mySpinner");
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    //document.getElementById(event.target.id).classList.remove("is-danger");
  };

  resendCode = () => {
    let { username, password } = JSON.parse(localStorage.getItem("userInfo"));
    Auth.resendSignUp({
      username: username
    })
      .then(response => {})
      .catch(e => {});
  };

  render() {
    let { username } = JSON.parse(localStorage.getItem("userInfo"));
    return (
      <div>
        <main ref="main">
          <ToastContainer />
          <section className="section section-shaped section-lg">
            <Container className=" pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg="6">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-white pb-2 pt-3">
                      <div className="pb-2">
                        <span style={{ fontSize: "30px" }}>
                          {" "}
                          Confirm Your Account{" "}
                        </span>
                      </div>
                    </CardHeader>

                    <CardBody className="bg-white  px-5 py-5">
                      <Form onSubmit={this.handleSubmit} role="form">
                        <FormGroup>
                          <InputGroup className=" input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText></InputGroupText>
                            </InputGroupAddon>

                            <Input value={username} id="username" readOnly />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText></InputGroupText>
                            </InputGroupAddon>
                            <Input
                              value={this.state.code}
                              id="code"
                              onChange={this.onInputChange}
                              placeholder="Confirmation Code"
                              type="text"
                            />
                          </InputGroup>
                        </FormGroup>
                        <Row>
                          <Col xs="auto">
                            <div
                              style={{
                                fontWeight: "bold",
                                fontSize: 12,
                                marginTop: 5,
                                marginBottom: 10
                              }}
                            >
                              Lost Your Code?
                              <span
                                onClick={() => this.resendCode()}
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer"
                                }}
                              >
                                Please Resend
                              </span>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="auto">
                            <div>
                              <Button
                                className=""
                                type="submit"
                                color="primary"
                              >
                                Confirm Code
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    profile: state.config.profile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeUser: data => dispatch(actionTypes.storeUser(data)),
    storeProfile: data => dispatch(actionTypes.storeProfile(data))
  };
};
export default ConfirmSignUp = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmSignUp);



// WEBPACK FOOTER //
// ./src/pages/ConfirmSignUp.js